import { useEffect, useState } from 'react';
import { X, Network, Users, Copy, FolderOpen, Waves } from 'lucide-react';
import { NST } from '../lib/netShareText';
import { inMode } from '../lib/profiles';
import { BR_ICON } from '../lib/pm';
import { pipeLatLngs, pathLength } from '../lib/model';

export const openNetShare = () => window.dispatchEvent(new Event('giss-net-open'));
const take = (id, how) => window.dispatchEvent(new CustomEvent('giss-net-take', { detail: { id, how } }));
const km = (p, l) => (p.pipes.reduce((s, x) => s + pathLength(pipeLatLngs(x, p.fittings)), 0) / 1000).toLocaleString(l, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

// leak detection: open a pipe network of another branch (e.g. AquaFlow demo Bozen) - shared or as copy
export default function NetShare({ lang, projects, current }) {
  const x = NST[lang] || NST.en, [open, setOpen] = useState(false);
  useEffect(() => { const on = () => setOpen(true); window.addEventListener('giss-net-open', on); return () => window.removeEventListener('giss-net-open', on); }, []);
  if (!open) return null;
  const list = projects.filter((p) => p.id !== current?.id && (p.pipes || []).length).sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
  const go = (id, how) => { setOpen(false); take(id, how); };
  return (
    <div className="editor-backdrop" data-testid="net-share-dialog" onClick={(e) => e.target === e.currentTarget && setOpen(false)}>
      <div className="editor net-share">
        <div className="editor-head"><b className="net-share-h"><Network size={16} /> {x.title}</b><button className="icon-btn" data-testid="net-share-close-btn" aria-label={x.close} onClick={() => setOpen(false)}><X size={16} /></button></div>
        <p className="muted small-hint">{x.hint}</p>
        {!list.length && <p data-testid="net-share-empty">{x.none}</p>}
        <ul className="net-share-list" data-testid="net-share-list">
          {list.map((p) => {
            const det = inMode(p, 'detect'), br = p.pm?.branches || [p.sector];
            return (
              <li key={p.id} data-testid={`net-share-item-${p.id}`}>
                <div><b title={p.title}>{br.map((b) => BR_ICON[b]).join('')} {p.title}</b><small className="muted">{x.pipes.replace('{n}', p.pipes.length).replace('{km}', km(p, lang))}{det ? ` · ${x.inDet}` : ''}</small></div>
                {det ? <button className="btn btn-sm btn-primary" data-testid={`net-share-open-${p.id}`} onClick={() => go(p.id, 'open')}><FolderOpen size={14} /> {x.open}</button> : <>
                  <button className="btn btn-sm btn-primary" title={x.shareT} data-testid={`net-share-share-${p.id}`} onClick={() => go(p.id, 'share')}><Users size={14} /> {x.share}</button>
                  <button className="btn btn-sm btn-outline" title={x.copyT} data-testid={`net-share-copy-${p.id}`} onClick={() => go(p.id, 'copy')}><Copy size={14} /> {x.copy}</button>
                </>}
              </li>
            );
          })}
        </ul>
        <p className="muted small-hint"><b>{x.share}:</b> {x.shareT}<br /><b>{x.copy}:</b> {x.copyT}</p>
        {!projects.some((p) => /bozen|bolzano/i.test(p.title || '')) && (
          <button className="btn btn-accent" data-testid="net-share-bozen-btn" title={x.bozenT} onClick={() => { setOpen(false); window.dispatchEvent(new CustomEvent('giss-aqua-demo', { detail: { kind: 'bozen', white: false, cross: true } })); }}><Waves size={15} /> {x.bozen}</button>
        )}
      </div>
    </div>
  );
}
